import { SxDynamicComponentsService } from './sx-dynamic-components.service';
import { SxCookieService } from './sx-cookie.service';
import { SxDialogService } from './sx-dialog.service';
import { SxSnackbarService } from './sx-snackbar.service';
import { SxErrorService } from './sx-error.service';
import { SxPermissionService } from './sx-permission.service';
import { SxReloadPermissionService } from './sx-reload-permission.service';
import { SxAccountRepairService } from './sx-account-repair.service';
import { SxExportService } from './sx-export.service';
import { SxRouterExtService } from './sx-previous-route.service';
import { SxNavigationMenuService } from './sx-navigation-menu.service';
import { SxApplicationInsightsService } from './sx-application-insights.service';
import { SxDynamicFilterComponentsService } from './sx-dynamic-filter-components.service';
import { SxFeedService } from './sx-feed.service';

export const services: any[] = [
  SxDynamicComponentsService,
  SxCookieService,
  SxDialogService,
  SxSnackbarService,
  SxErrorService,
  SxPermissionService,
  SxReloadPermissionService,
  SxAccountRepairService,
  SxExportService,
  SxRouterExtService,
  SxNavigationMenuService,
  SxApplicationInsightsService,
  SxDynamicFilterComponentsService,
  SxFeedService
];

export * from './sx-dynamic-components.service';
export * from './sx-cookie.service';
export * from './sx-dialog.service';
export * from './sx-snackbar.service';
export * from './sx-error.service';
export * from './sx-permission.service';
export * from './sx-reload-permission.service';
export * from './sx-account-repair.service';
export * from './sx-export.service';
export * from './sx-previous-route.service';
export * from './sx-navigation-menu.service';
export * from './sx-application-insights.service';
export * from './sx-dynamic-filter-components.service';
export * from './sx-feed.service';